// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("update_calendar_icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_container {
    min-width: 572px;
    background-color: white;
    position: relative;
    z-index: 2;
    padding: 0 20px 20px 20px;
}

.update_modal_row {
    display: flex;
    gap: 20px;
}
@media (max-width: 600px) {
    .modal_container {
        min-width: auto;
        width: 80vw;
        padding: 0 14px 14px 14px;
    }
    .active_icon_plans_submit {
        display: none;
    }
}

.modal_container_big {
    min-width: 90vw;
    max-width: 95vw;
    max-height: 95vh;
    position: relative;
    z-index: 9999;
    padding: 20px;
}

.modal_bg {
    width: 100%;
    min-width: 100%;
    min-height: 100%;
    background-color: #F2F2F4;
    padding: 20px;
}

.white {
    background-color: #ffffff;
}
@media (max-width: 1000px) {
    .plans_modal_filter {
        display: block;
    }
    .plans_modal_filter > div {
        margin-bottom: 10px;
    }
}
.modal_container > h2 {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 2rem;
}
.close_popup {
    position: absolute;
    width: 18px;
    top: 5px;
    right: 5px;
    cursor: pointer;
}
.close_popup_paddings {
    position: absolute;
    width: 15px;
    top: 15px;
    right: 15px;
    cursor: pointer;
}
.success_pop_img {
    margin-top: 15px;
    margin-bottom: 50px;
    width: 80px;
}
.modal_line {
    width: 100%;
    height: 1px;
    margin-top: 20px;
    background-color: #9FACC7;
}
.modal_container > p {
    font-size: 16px;
    font-weight: 600;
    padding-top: 15px;
    margin-bottom: 20px;
}
.modal_btn_container {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.modal_cancel_btn {
    margin-right: 20px;
    font-weight: 700;
    cursor: pointer;
}
/* PLANS AND MODULES */
.plans_pop_text {
    font-size: 0.9rem;
    line-height: 1.2rem;
    font-family: Montserrat, sans-serif;
    font-weight: 600;
    letter-spacing: 0.05rem;
    color: #4A4A4A;
}
.filter_header {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.modal_close_text {
    width: 100%;
    margin-top: 0.8rem;
    font-weight: 600;
    cursor: pointer;
}

/* COMPLETE PROFILE */
.complete_title {
    font-size: 1.5rem!important;
    padding-top: 1rem;
    margin-bottom: 3rem;
    text-align: center;
}
.complete_row_selected {
    width: 100%;
    height: 50px;
    border-radius: 5px;
    border: 1px solid rgba(30, 192, 166, 0.55);
    background-color: rgba(30, 192, 166, 0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-bottom: 0.5rem;
}
.complete_text {
    font-size: 1rem;
    font-weight: 600;
    padding-left: 0.6rem;
}
.complete_text_completed {
    font-weight: 600;
    color: #1EC0A6;
}
.complete_text_complete_now {
    color: #515DA7;
    font-weight: 600;
    cursor: pointer;
}
.complete_row_selected:last-child {
    margin-bottom: 5rem;
}

.csv_pop_wrapper {
    padding: 2rem;
    width: 100%;
    max-width: 1100px;
    margin-left: auto;
    margin-right: auto;
}

.perm_table_select {
    max-width: 120px;
}

.search_box_permissions {
    max-width: 180px;
    margin-top: 20px;
    margin-bottom: 1rem;
}

.employee_desktop_button {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.employee_mobile_button {
    display: none;
}

.validate_warning_csv {
    display: flex;
    max-width: 100%;
    flex-wrap: wrap;
    column-gap: 10px;
}

.validate_warning_csv > p {
    font-size: 12px;
    color: #DC3545;
    cursor: pointer;
    font-weight: 600;
}

@media (max-width: 600px) {
    .employee_desktop_button {
        display: none;
    }
    .employee_mobile_button {
        display: block;
    }
}


.changelog_modal {
    max-width: 80vw;
    max-height: 80vh;
    position: relative;
    z-index: 1000;
}


.changelog_wrapper > ul, .changelog_wrapper > ul > li{
    list-style: none;
    padding: 0;
}

.changelog_wrapper{
    padding: 2rem;
    overflow: auto;
}
.sessions{
    margin-top: 2rem;
    border-radius: 12px;
    position: relative;
}
.changelog_wrapper > ul > li {
    padding-bottom: 1.5rem;
    border-left: 1px solid #A2ADBF;
    position: relative;
    padding-left: 20px;
    margin-left: 10px;
}
.changelog_wrapper > ul > li:last-child{
    border: 0px;
    padding-bottom: 0;
}
.changelog_wrapper > ul > li:before{
    content: '';
    width: 25px;
    height: 25px;
    background-color: white;
    background-size: cover;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: absolute;
    left: -12px;
    top: 0px;
}

.time {
    padding-top: 3px;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #A2ADBF;
}

.changelog_name {
    font-size: 12px;
    font-weight: 600;
    color: rgba(19,15,48,0.65);
}

.changelog_badge {
    width: max-content;
    padding: 5px 10px;
    border-radius: 3px;
    font-weight: 600;
    letter-spacing: 0.5px;
    font-size: 11px;
    color: #f2a338;
    background-color: rgba(255, 236, 206, 0.8);
}
`, "",{"version":3,"sources":["webpack://./src/Components/SimpleComponents/Modal.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI;QACI,eAAe;QACf,WAAW;QACX,yBAAyB;IAC7B;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,UAAU;IACV,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;AACA,sBAAsB;AACtB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,0CAA0C;IAC1C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;AACJ;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;;AAGA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,yDAAiD;IACjD,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,0CAA0C;AAC9C","sourcesContent":[".modal_container {\n    min-width: 572px;\n    background-color: white;\n    position: relative;\n    z-index: 2;\n    padding: 0 20px 20px 20px;\n}\n\n.update_modal_row {\n    display: flex;\n    gap: 20px;\n}\n@media (max-width: 600px) {\n    .modal_container {\n        min-width: auto;\n        width: 80vw;\n        padding: 0 14px 14px 14px;\n    }\n    .active_icon_plans_submit {\n        display: none;\n    }\n}\n\n.modal_container_big {\n    min-width: 90vw;\n    max-width: 95vw;\n    max-height: 95vh;\n    position: relative;\n    z-index: 9999;\n    padding: 20px;\n}\n\n.modal_bg {\n    width: 100%;\n    min-width: 100%;\n    min-height: 100%;\n    background-color: #F2F2F4;\n    padding: 20px;\n}\n\n.white {\n    background-color: #ffffff;\n}\n@media (max-width: 1000px) {\n    .plans_modal_filter {\n        display: block;\n    }\n    .plans_modal_filter > div {\n        margin-bottom: 10px;\n    }\n}\n.modal_container > h2 {\n    font-size: 18px;\n    font-weight: 600;\n    text-align: center;\n    margin-bottom: 2rem;\n}\n.close_popup {\n    position: absolute;\n    width: 18px;\n    top: 5px;\n    right: 5px;\n    cursor: pointer;\n}\n.close_popup_paddings {\n    position: absolute;\n    width: 15px;\n    top: 15px;\n    right: 15px;\n    cursor: pointer;\n}\n.success_pop_img {\n    margin-top: 15px;\n    margin-bottom: 50px;\n    width: 80px;\n}\n.modal_line {\n    width: 100%;\n    height: 1px;\n    margin-top: 20px;\n    background-color: #9FACC7;\n}\n.modal_container > p {\n    font-size: 16px;\n    font-weight: 600;\n    padding-top: 15px;\n    margin-bottom: 20px;\n}\n.modal_btn_container {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n}\n.modal_cancel_btn {\n    margin-right: 20px;\n    font-weight: 700;\n    cursor: pointer;\n}\n/* PLANS AND MODULES */\n.plans_pop_text {\n    font-size: 0.9rem;\n    line-height: 1.2rem;\n    font-family: Montserrat, sans-serif;\n    font-weight: 600;\n    letter-spacing: 0.05rem;\n    color: #4A4A4A;\n}\n.filter_header {\n    width: 100%;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n}\n\n.modal_close_text {\n    width: 100%;\n    margin-top: 0.8rem;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n/* COMPLETE PROFILE */\n.complete_title {\n    font-size: 1.5rem!important;\n    padding-top: 1rem;\n    margin-bottom: 3rem;\n    text-align: center;\n}\n.complete_row_selected {\n    width: 100%;\n    height: 50px;\n    border-radius: 5px;\n    border: 1px solid rgba(30, 192, 166, 0.55);\n    background-color: rgba(30, 192, 166, 0.05);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    margin-bottom: 0.5rem;\n}\n.complete_text {\n    font-size: 1rem;\n    font-weight: 600;\n    padding-left: 0.6rem;\n}\n.complete_text_completed {\n    font-weight: 600;\n    color: #1EC0A6;\n}\n.complete_text_complete_now {\n    color: #515DA7;\n    font-weight: 600;\n    cursor: pointer;\n}\n.complete_row_selected:last-child {\n    margin-bottom: 5rem;\n}\n\n.csv_pop_wrapper {\n    padding: 2rem;\n    width: 100%;\n    max-width: 1100px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.perm_table_select {\n    max-width: 120px;\n}\n\n.search_box_permissions {\n    max-width: 180px;\n    margin-top: 20px;\n    margin-bottom: 1rem;\n}\n\n.employee_desktop_button {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.employee_mobile_button {\n    display: none;\n}\n\n.validate_warning_csv {\n    display: flex;\n    max-width: 100%;\n    flex-wrap: wrap;\n    column-gap: 10px;\n}\n\n.validate_warning_csv > p {\n    font-size: 12px;\n    color: #DC3545;\n    cursor: pointer;\n    font-weight: 600;\n}\n\n@media (max-width: 600px) {\n    .employee_desktop_button {\n        display: none;\n    }\n    .employee_mobile_button {\n        display: block;\n    }\n}\n\n\n.changelog_modal {\n    max-width: 80vw;\n    max-height: 80vh;\n    position: relative;\n    z-index: 1000;\n}\n\n\n.changelog_wrapper > ul, .changelog_wrapper > ul > li{\n    list-style: none;\n    padding: 0;\n}\n\n.changelog_wrapper{\n    padding: 2rem;\n    overflow: auto;\n}\n.sessions{\n    margin-top: 2rem;\n    border-radius: 12px;\n    position: relative;\n}\n.changelog_wrapper > ul > li {\n    padding-bottom: 1.5rem;\n    border-left: 1px solid #A2ADBF;\n    position: relative;\n    padding-left: 20px;\n    margin-left: 10px;\n}\n.changelog_wrapper > ul > li:last-child{\n    border: 0px;\n    padding-bottom: 0;\n}\n.changelog_wrapper > ul > li:before{\n    content: '';\n    width: 25px;\n    height: 25px;\n    background-color: white;\n    background-size: cover;\n    background-image: url(\"update_calendar_icon.svg\");\n    position: absolute;\n    left: -12px;\n    top: 0px;\n}\n\n.time {\n    padding-top: 3px;\n    font-size: 12px;\n    font-weight: 600;\n    margin-bottom: 10px;\n    color: #A2ADBF;\n}\n\n.changelog_name {\n    font-size: 12px;\n    font-weight: 600;\n    color: rgba(19,15,48,0.65);\n}\n\n.changelog_badge {\n    width: max-content;\n    padding: 5px 10px;\n    border-radius: 3px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    font-size: 11px;\n    color: #f2a338;\n    background-color: rgba(255, 236, 206, 0.8);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
